import { ZfBox } from '@zafire/react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { DIALOG_GRID_PADDING, getMaxDialogTileWidth, GRID_COLUMNS, GRID_GAP } from '../../../utils/topicUtils';

const topicGrid = {
    display: 'grid',
    gap: `${GRID_GAP}px`,
    p: `${DIALOG_GRID_PADDING}px`,
};

interface IProps extends PropsWithChildren {
    width: number;
    aspectRatio: number;
}

export const TopicDialogGrid: FunctionComponent<IProps> = ({ width, aspectRatio, children }) => {
    // (containerWidth - columnGapsWidth - containerPadding) / <number of columns>
    const maxTileWidth = getMaxDialogTileWidth(width);
    const maxTileHeight = maxTileWidth * aspectRatio;

    return (
        <ZfBox
            style={{
                ...topicGrid,
                gridTemplateColumns: `repeat(${GRID_COLUMNS}, ${maxTileWidth}px)`,
                gridTemplateRows: `minMax(auto, ${maxTileHeight}px)`,
            }}
        >
            {children}
        </ZfBox>
    );
};
